'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('../../../../components/Formatted/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _imageWithFallback = require('@liveauctioneers/caterwaul-components/lib/imageWithFallback');

var _imageWithFallback2 = _interopRequireDefault(_imageWithFallback);

var _Trust = require('./Trust.scss');

var _Trust2 = _interopRequireDefault(_Trust);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Trust = function (_PureComponent) {
    (0, _inherits3.default)(Trust, _PureComponent);

    function Trust() {
        (0, _classCallCheck3.default)(this, Trust);
        return (0, _possibleConstructorReturn3.default)(this, (Trust.__proto__ || (0, _getPrototypeOf2.default)(Trust)).apply(this, arguments));
    }

    (0, _createClass3.default)(Trust, [{
        key: 'render',
        value: function render() {
            return (0, _jsx3.default)('div', {
                className: _Trust2.default.trust
            }, void 0, (0, _jsx3.default)('div', {
                className: _Trust2.default.centered
            }, void 0, (0, _jsx3.default)('div', {
                className: _Trust2.default.images
            }, void 0, (0, _jsx3.default)('div', {
                className: _Trust2.default['column-title']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'as_seen_on'
            })), (0, _jsx3.default)('div', {
                className: _Trust2.default['column-content']
            }, void 0, (0, _jsx3.default)('div', {
                className: _Trust2.default.nbc
            }, void 0, (0, _jsx3.default)(_imageWithFallback2.default, {
                style: { maxHeight: '43px', maxWidth: '44px' },
                src: 'https://p1.liveauctioneers.com/dist/images/NBC.svg',
                alt: 'NBC'
            })), (0, _jsx3.default)('div', {
                className: _Trust2.default.abc
            }, void 0, (0, _jsx3.default)(_imageWithFallback2.default, {
                style: { maxHeight: '38px', maxWidth: '38px' },
                src: 'https://p1.liveauctioneers.com/dist/images/ABC.svg',
                alt: 'ABC'
            })), (0, _jsx3.default)('div', {
                className: _Trust2.default.today
            }, void 0, (0, _jsx3.default)(_imageWithFallback2.default, {
                style: { maxHeight: '42px', maxWidth: '57px' },
                src: 'https://p1.liveauctioneers.com/dist/images/TODAY.svg',
                alt: 'Today'
            })), (0, _jsx3.default)('div', {
                className: _Trust2.default['chicago-tribune']
            }, void 0, (0, _jsx3.default)(_imageWithFallback2.default, {
                style: { maxHeight: '20px', maxWidth: '137px' },
                src: 'https://p1.liveauctioneers.com/dist/images/ChicagoTribune.svg',
                alt: 'Chicago Tribune'
            })), (0, _jsx3.default)('div', {
                className: _Trust2.default['architectural-digest']
            }, void 0, (0, _jsx3.default)(_imageWithFallback2.default, {
                style: { maxHeight: '14px', maxWidth: '162px' },
                src: 'https://p1.liveauctioneers.com/dist/images/ArchDigest.svg',
                alt: 'Architectural Digest'
            })))), (0, _jsx3.default)('div', {
                className: _Trust2.default.separator
            }), (0, _jsx3.default)('div', {
                className: _Trust2.default.shop
            }, void 0, (0, _jsx3.default)('div', {
                className: _Trust2.default['column-title']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'shop_with_confidence'
            })), (0, _jsx3.default)('div', {
                className: _Trust2.default['column-content']
            }, void 0, (0, _jsx3.default)('div', {
                className: _Trust2.default['column-content-left']
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'since_2002_liveauctioneers_has_made_items'
            })), (0, _jsx3.default)('div', {
                className: _Trust2.default['column-content-right']
            }, void 0, (0, _jsx3.default)('a', {
                href: 'http://www.bbb.org/new-york-city/business-reviews/internet-auction-service/live-auctioneers-llc-in-new-york-ny-123530/#bbbonlineclick',
                target: '_blank',
                rel: 'nofollow noopener'
            }, void 0, (0, _jsx3.default)(_imageWithFallback2.default, {
                src: 'https://p1.liveauctioneers.com/seals/blue-seal-250-52-bbb-123530.png',
                alt: 'LiveAuctioneers LLC BBB Business Review',
                style: { height: '52px', width: '250px' }
            })))))));
        }
    }]);
    return Trust;
}(_react.PureComponent);

exports.default = Trust;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LAFooter/Trust/Trust.js
// module id = yMle
// module chunks = 60